import React from 'react';
import { useTranslation } from '@shared/core';
import { ReactComponent as CloseSvg } from '@assets/icons/circle-close.svg';
import { ReactComponent as SearchChrevon } from '@assets/icons/search-forward-chevron.svg';
import { ReactComponent as SearchSVG } from '@assets/icons/search.svg';
import { Box, DrawerV2, Flex } from '@withjoy/joykit';
import { DRAWER_OVERRIDES, StyledSearchContainer, StyledSearchInput, StyledSearchButton } from './SearchInputDrawer.styles';
import { useResponsive } from '@shared/utils/hooks/useResponsive';

interface SearchBarProps {
  isOpen: boolean;
  handleOnOutsideclick: () => void;
  handleCancelClick(e: React.SyntheticEvent): void;
  handleOnKeyDown: React.KeyboardEventHandler;
  clearSearchText: () => void;
  handleOnSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  handleOnChange: React.ChangeEventHandler<HTMLInputElement>;
  searchText: string;
}
export const SearchInputDrawer: React.FC<SearchBarProps> = ({
  isOpen,
  handleCancelClick,
  clearSearchText,
  handleOnOutsideclick,
  handleOnChange,
  handleOnKeyDown,
  handleOnSubmit,
  searchText
}: SearchBarProps) => {
  const { t2 } = useTranslation('catalogRegistry');
  const t2Search = t2('searchBar');
  const [isMobile] = useResponsive({ values: { mobile: true, tablet: false } });
  const hasInputValue = !!searchText.length;

  return (
    <DrawerV2 useBackdrop={!!isMobile} isOpen={isOpen} anchor="top" size={148} onClose={args => handleOnOutsideclick()} overrides={DRAWER_OVERRIDES}>
      <Flex alignItems="center" justifyContent="space-between" height={'100%'} marginX={['34px', '88px']}>
        <Flex
          as="form"
          action="."
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onSubmit={(e: any) => handleOnSubmit(e as React.FormEvent<HTMLFormElement>)}
          width="100%"
          justifyContent="space-between"
        >
          <StyledSearchContainer isMobile={isMobile} alignItems={'center'}>
            <SearchSVG />
            <StyledSearchInput
              width={'100%'}
              placeholder={!isMobile ? t2Search.searchInputPlaceholder : t2Search.searchInputPlaceholderMobile}
              minimal={true}
              onChange={handleOnChange}
              onKeyDown={handleOnKeyDown}
              type="search"
              // eslint-disable-next-line jsx-a11y/no-autofocus
              autoFocus={true}
              value={searchText}
            />
          </StyledSearchContainer>
          <Flex justifyContent={hasInputValue ? (isMobile ? 'center' : 'space-between') : 'end'} alignItems={'center'}>
            <Box as="a" display={hasInputValue ? 'flex' : 'none'} alignItems={'center'} onClick={clearSearchText} marginRight={isMobile ? 5 : 0}>
              <CloseSvg />
            </Box>
            <StyledSearchButton as="button" isMobile={isMobile} visible={hasInputValue} type="submit">
              <SearchChrevon />
              {!isMobile && t2Search.searchInputPlaceholderMobile}
            </StyledSearchButton>
            {(!isMobile || (isMobile && !hasInputValue)) && (
              <Box as="a" display="flex" alignItems={'center'} onClick={handleCancelClick}>
                Cancel
              </Box>
            )}
          </Flex>
        </Flex>
      </Flex>
    </DrawerV2>
  );
};
